import React from "react";
import "../styles.css";
import defaultImage from "../assets/default.jpg";

export default function MovieCard({
  movie,
  isWatchlisted,
  toggleWatchlist,
  genres = {},
}) {
  const handleError = (e) => {
    e.target.src = defaultImage; // ✅ use imported default image
  };

  const getRatingClass = (rating) => {
    if (rating >= 8) return "rating-good";
    if (rating >= 5) return "rating-ok";
    return "rating-bad";
  };

  // ✅ Build poster URL from TMDb OR fallback to default
  const posterUrl = movie.poster_path
    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
    : defaultImage;

  // ✅ Convert genre_ids into readable names
  const genreNames = movie.genre_ids
    ? movie.genre_ids
        .map((id) => genres[id])
        .filter(Boolean)
        .join(", ")
    : "Unknown";

  return (
    <div key={movie.id} className="movie-card">
      <img src={posterUrl} alt={movie.title} onError={handleError} />

      <div className="movie-card-info">
        <h3 className="movie-card-title">{movie.title}</h3>
        <div>
          <span
            className={`movie-card-rating ${getRatingClass(
              movie.vote_average
            )}`}
          >
            {movie.vote_average?.toFixed(1)}
          </span>
          <span className="movie-card-genre">{genreNames}</span>
        </div>

        <label className="switch">
          <input
            type="checkbox"
            checked={isWatchlisted}
            onChange={() => toggleWatchlist(movie.id)}
          />
          <span className="slider">
            <span className="slider-label">
              {isWatchlisted ? "In Watchlist" : "Add to Watchlist"}
            </span>
          </span>
        </label>
      </div>
    </div>
  );
}
